import { Endpoint } from '@business/api/endpoint';
import {
  CompactLibraryFolderResponse,
  CompactLibraryItemResponse,
  FolderId,
  ItemId,
  LibraryFolderStructureResponse,
  LibraryItemResponse,
  LibraryItemShareItem,
  LibraryItemShareType,
  LibraryItemsResponse,
  LibraryItemType,
  // LibraryItemVersionResponse,
  LibraryResponse,
  LibraryVersionId,
  LibraryItemStatus,
  LibraryItemAssigneeType,
} from '@business/entities/library';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';

export function getItems(parentId?: FolderId) {
  return Endpoint.get<LibraryItemsResponse>(`@makh/library`, { params: { parentId } });
}

export function getFolders() {
  return Endpoint.get<CompactLibraryFolderResponse[]>(`@makh/library/folders`);
}

/** Folders **/
export function createFolder(name: string, parentId?: FolderId) {
  return Endpoint.post<LibraryResponse>(`@makh/library`, { data: { name, parentId } });
}

export function renameFolder(id: FolderId, name: string) {
  return Endpoint.patch<LibraryResponse>(`@makh/library/${id}`, { data: { name } });
}
export function deleteFolder(id: FolderId) {
  return Endpoint.delete<void>(`@makh/library/${id}`);
}

/** Items **/

export function getItem(id: ItemId) {
  return Endpoint.get<LibraryItemResponse>(`@makh/library/item/${id}`);
}

export function getItemPublic(id: ItemId) {
  return Endpoint.get<LibraryItemResponse>(`@makh/public/library/item/${id}`);
}

export function download(id: ItemId, filename: string) {
  return Endpoint.get<LibraryItemResponse>(`@makh/library/download/${id}`, { isFile: true, filename });
}

export function createItem(data: Partial<LibraryItemResponse>, parentId?: FolderId) {
  data.parentFolderId = parentId;
  // if (data.type == LibraryItemType.policy || data.type == LibraryItemType.article) {
  //   return Endpoint.post<LibraryItemResponse[]>(`@makh/library/item`, { data });
  // }
  const formData = CommonService.toFormData(data);
  return Endpoint.post<LibraryItemResponse[]>(`@makh/library/item`, { formData, hasFiles: true });
}

export function duplicateItem(id: ItemId, title: string) {
  return Endpoint.post<LibraryItemResponse>(`@makh/library/duplicate/${id}`, { data: { title } });
}

export function updateItem(data: Partial<LibraryItemResponse>, itemId: ItemId) {
  // if (data.type === LibraryItemType.orgChart || data.type === LibraryItemType.flowChart) {
  //   return Endpoint.post<LibraryItemResponse>(`@makh/library/update-item/${itemId}`, { data });
  // }
  const formData = CommonService.toFormData(data);
  return Endpoint.post<LibraryItemResponse>(`@makh/library/update-item/${itemId}`, { formData, hasFiles: true });
}

export function shareItem(id: ItemId, items: LibraryItemShareItem[] = [], type: LibraryItemShareType = LibraryItemShareType.item) {
  return Endpoint.post<LibraryItemResponse | LibraryResponse>(`@makh/library/share/${id}`, { data: { items, type } });
}

export function deleteItem(id: ItemId) {
  return Endpoint.delete<void>(`@makh/library/item/${id}`);
}
export function search(search: string, type: LibraryItemType, parentId?: FolderId) {
  const params = R.objectCompact({ search, parentId, type });
  return Endpoint.get<CompactLibraryItemResponse[]>(`@makh/library/search`, { params });
}

export function removeFile(id: ItemId, index: number) {
  return Endpoint.post<CompactLibraryItemResponse>(`@makh/library/remove-attachment/${id}`, { params: { index } });
}

export function folderStructure(folderId: FolderId) {
  return Endpoint.get<LibraryFolderStructureResponse>(`@makh/library/folder-structure`, { params: { folderId } });
}

export function move(id: string, type: LibraryItemType, destinationId: string) {
  return Endpoint.post<void>(`@makh/library/move`, { data: { id, type, destinationId } });
}

export function getLibraryItems(type: string) {
  return Endpoint.get<CompactLibraryItemResponse[]>(`@makh/library/items`, { params: { type } });
}

// export function renameVersion(id: LibraryVersionId, title: string) {
//   return Endpoint.patch<LibraryItemVersionResponse[]>(`@makh/library/version/${id}`, { data: { title } });
// }

// export function deleteVersion(id: LibraryVersionId) {
//   return Endpoint.delete<LibraryItemVersionResponse[]>(`@makh/library/version/${id}`);
// }

export function onStatusChange(id: ItemId, status: LibraryItemStatus) {
  return Endpoint.post<LibraryItemResponse>(`@makh/library/change-status/${id}`, { data: { status } });
}

export function updateAssignne(type: string, id: number | string, items: string[]) {
  return Endpoint.post<LibraryItemAssigneeType>(`@makh/library/assignee`, { data: { type, id, items } });
}

export function createMedia(data: Partial<LibraryItemResponse>, parentId?: FolderId) {
  data.parentFolderId = parentId;
  const formData = CommonService.toFormData(data);
  return Endpoint.post<LibraryItemResponse[]>(`@makh/library/create-media`, { formData, hasFiles: true });
}

export function updateMedia(data: Partial<LibraryItemResponse>, itemId: ItemId) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<LibraryItemResponse>(`@makh/library/update-media/${itemId}`, { formData, hasFiles: true });
}
